module.exports = __webpack_public_path__ + "img/product_93.af73f9c.webp";